import { HelperAppState } from './state';
import { MutationTree } from 'vuex';

const mutations: MutationTree<HelperAppState> = {
  SET_LOADING_APP_MUTATION(state, value: boolean) {
    state.loading = value;
  },
};

export default mutations;
